export default __webpack_public_path__ + "static/media/ord-pack-nv.bf91c94b.png";